(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    var container = document.querySelector('[data-currency-selector]');
    if (!container) return;

    var button = container.querySelector('.currency-selector--button');
    var list = container.querySelector('.currency-selector--list');
    var input = container.querySelector('input[name="country_code"]');

    if (!button || !list || !input) return;

    function toggleList() {
      var isHidden = list.hasAttribute('hidden');
      if (isHidden) {
        list.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      } else {
        list.setAttribute('hidden', 'hidden');
        button.setAttribute('aria-expanded', 'false');
      }
    }

    button.addEventListener('click', function () {
      toggleList();
    });

    list.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-value]');
      if (!link) return;

      event.preventDefault();
      var value = link.getAttribute('data-value');
      input.value = value;

      var form = container.closest('form');
      if (form) form.submit();
    });

    document.addEventListener('click', function (event) {
      if (!container.contains(event.target) && !list.hasAttribute('hidden')) {
        list.setAttribute('hidden', 'hidden');
        button.setAttribute('aria-expanded', 'false');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
